import { render, staticRenderFns } from "./UpdatePackage.vue?vue&type=template&id=cad793f4&"
import script from "./UpdatePackage.vue?vue&type=script&lang=js&"
export * from "./UpdatePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports